import { lightYellow } from '@synoptic/ui-kit/palette.js';
import { style } from '@vanilla-extract/css';

export const medalFallback = style({
  borderRadius: '100%',
  backgroundColor: lightYellow[400],
  objectFit: 'scale-down',
});

export const medal = style({
  borderRadius: '100%',
  backgroundColor: lightYellow[400],
});
